import './JiraIssueMappingTooltip.scss';
import { createAsyncSelectors } from '@lib/selectors';
import { Link } from 'react-router-dom';
import React from 'react';
import { SonarText } from '@ui/text';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { Else, If, Then } from 'react-if';
export const jiraSyncSelector = createAsyncSelectors((state) => state.integrations.jira.initiatives.sync.post);
export const JiraIssueMappingTooltip = ({ missingMapping }) => React.createElement(SonarText, { className: 'jira-issue-status-warning' },
    React.createElement(If, { condition: missingMapping },
        React.createElement(Then, null, COPY_SPECIFIC.JIRA_UNMAPPED_STATUS),
        React.createElement(Else, null, COPY_SPECIFIC.JIRA_INCOMPLETE_STATUS)),
    React.createElement(Link, { to: `${FULL_ROUTES.SETTINGS_JIRA}` }, COPY_SPECIFIC.GO_TO_SETTINGS),
    COPY_SPECIFIC.JIRA_SET_UP_MAPPING);
